import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Dialog } from '@material-ui/core'
import PropTypes from 'prop-types'

const useStyles = makeStyles(theme => ({
  dialogPaper: {
    borderRadius: 10
  }
}))
const DialogAster = ({ open, onClose, ...props }) => {
  const classes = useStyles()
  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{ paper: classes.dialogPaper }}
      {...props}
    >
      {props.children}
    </Dialog>
  )
}
export default DialogAster
DialogAster.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node
}
